import { Spinner } from '@/components/ui/spinner';
import { useT } from '@/str';

import { CENTER } from './center';

export function Loader() {
  const t = useT();
  return (
    <div className={CENTER}>
      <Spinner className="text-accent-ink size-8" aria-label={t.srLoading} />
    </div>
  );
}
